import { AdSpendCard as BaseAdSpendCard } from '@features/campaigns/components/AdSpendCard';
import {
  HeroMetric,
  HeroMetricProps,
} from '@features/campaigns/components/Summary/HeroMetric';
import { formatters } from '@utils/formattersV2';
import { faDollar } from '@fortawesome/pro-solid-svg-icons';
import { AdSpendHeroMetric } from '../AdSpendHeroMetric';
import {
  useCostPerVisit,
  UseCostPerVisitOptions,
} from '@features/campaigns/subdomains/visitation/hooks';
import { useCurrentAdSpend } from '../../../hooks/useAdSpend';

const COLOR_SCHEME: HeroMetricProps['colorScheme'] = 'visit';

type AdSpendCardProps = {
  campaign: UseCostPerVisitOptions['campaign'];
  totalVisits: number | null;
  incrementalVisits: number | null;
  reportDate: string;
};

export const AdSpendCard = (props: AdSpendCardProps) => {
  const adSpendHook = useCurrentAdSpend();

  const report: UseCostPerVisitOptions['report'] = {
    reportDate: props.reportDate,
    visitMetrics: {
      projectedVisits: props.totalVisits,
      incrementalVisits: props.incrementalVisits,
    },
  };
  const { value: costPerVisit } = useCostPerVisit({
    campaign: props.campaign,
    report,
    visitsField: 'projectedVisits',
    adSpend: adSpendHook.adSpend ?? 0,
  });

  const { value: costPerIncrementalVisit } = useCostPerVisit({
    campaign: props.campaign,
    report,
    visitsField: 'incrementalVisits',
    adSpend: adSpendHook.adSpend ?? 0,
  });

  return (
    <BaseAdSpendCard
      color={COLOR_SCHEME}
      metrics={[
        {
          key: 'iroas',
          render: () => (
            <HeroMetric
              value={costPerVisit}
              valueFormatter={formatters.currency}
              colorScheme={COLOR_SCHEME}
              label="Cost per Visit"
              icon={faDollar}
              data-testid="cpv"
            />
          ),
        },
        {
          key: 'roas',
          render: () => (
            <HeroMetric
              value={costPerIncrementalVisit}
              valueFormatter={formatters.currency}
              colorScheme="visit"
              label="Cost per Incremental Visit"
              icon={faDollar}
              data-testid="cpiv"
            />
          ),
        },
      ]}
    >
      <AdSpendHeroMetric
        colorScheme={COLOR_SCHEME}
        value={adSpendHook.adSpend}
      />
    </BaseAdSpendCard>
  );
};
